import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, tap, throwError } from 'rxjs';
import { Institucion } from './institucion.model';
import { environment } from 'src/environments/environment';
import urlJoin from 'url-join';
import { ActivatedRoute } from "@angular/router";
import { NotificationsService } from '../core/service/notifications.service';

@Injectable({
  providedIn: 'root' // Poner aquí esta declaración hace que no sea necesario meterlo en providers de app.module
})
export class ParticipantesService {

  private participantesURL: string = urlJoin(environment.apiURL, 'participantes')

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private notificationsService: NotificationsService
  ) { }

  getInstituciones(id_expediente: string): Observable<Institucion[]> {
    const getparticipantesURL = urlJoin(this.participantesURL, '/expediente/', id_expediente)
    return this.http.get<Institucion[]>(getparticipantesURL)
      .pipe(
        tap(() => {
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  getInstitucion(id: string): Observable<any> {
    const getInstitucionURL = urlJoin(this.participantesURL, id)
    return this.http.get<Institucion>(getInstitucionURL)
      .pipe(
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  updateInstitucion(id: string, institucion: Institucion): Observable<any> {
    const updateInstitucionURL = urlJoin(this.participantesURL, id)
    return this.http.put<Institucion>(updateInstitucionURL, institucion)
      .pipe(
        tap(() => {
          const updateInstitucionSuccessMessage: string = $localize`:@@updateInstitucionSuccessMessage:Participante modificado correctamente`;
          this.notificationsService.showSuccessNotification(updateInstitucionSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  deleteInstitucion(id: string): Observable<any> {
    const deleteInstitucionURL = urlJoin(this.participantesURL, id)
    return this.http.delete<Institucion>(deleteInstitucionURL)
      .pipe(
        tap(() => {
          const deleteInstitucionSuccessMessage: string = $localize`:@@deleteInstitucionSuccessMessage:Participante eliminado correctamente`;
          this.notificationsService.showSuccessNotification(deleteInstitucionSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  newInstitucion(institucion: Institucion): Observable<any> {
    const newInstitucionURL = urlJoin(this.participantesURL, "/expediente")
    return this.http.post<Institucion>(newInstitucionURL, institucion)
      .pipe(
        tap((response) => {
            const newInstitucionSuccessMessage: string = $localize`:@@newInstitucionSuccessMessage:Nuevo participante añadido correctamente`;
            this.notificationsService.showSuccessNotification(newInstitucionSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

}
